import {GeoFaqItem} from './geoContent.mock';
import {GeoHubRestaurant} from './geoHubData';
import {absoluteUrl} from './geoRoutes';

/** Max venues in ItemList JSON-LD (full list stays in HTML). */
export const GEO_ITEM_LIST_SCHEMA_MAX = 25;

export type BreadcrumbSchemaItem = {
    name: string;
    /** Omit on the last crumb when it is the current page URL passed separately */
    item?: string;
};

export function buildFaqPageSchema(faq: GeoFaqItem[]) {
    if (faq.length === 0) {
        return null;
    }
    return {
        '@type': 'FAQPage',
        mainEntity: faq.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
        })),
    };
}

export function buildBreadcrumbListSchema(items: BreadcrumbSchemaItem[]) {
    return {
        '@type': 'BreadcrumbList',
        itemListElement: items.map((crumb, index) => {
            const entry: Record<string, unknown> = {
                '@type': 'ListItem',
                position: index + 1,
                name: crumb.name,
            };
            if (crumb.item) {
                entry.item = crumb.item;
            }
            return entry;
        }),
    };
}

type RestaurantListSchemaInput = {
    name: string;
    restaurants: Array<{
        name: string;
        description: string;
        soltPath?: string;
    }>;
    maxItems?: number;
    /** Used when a venue has no public Solt page URL */
    fallbackUrl?: string;
};

export function buildRestaurantItemListSchema({
    name,
    restaurants,
    maxItems = GEO_ITEM_LIST_SCHEMA_MAX,
    fallbackUrl,
}: RestaurantListSchemaInput) {
    const slice = restaurants.slice(0, maxItems);
    if (slice.length === 0) {
        return null;
    }

    return {
        '@type': 'ItemList',
        name,
        numberOfItems: slice.length,
        itemListElement: slice.map((r, index) => {
            const item: Record<string, unknown> = {
                '@type': 'ListItem',
                position: index + 1,
                name: r.name,
                description: r.description,
            };
            const url = r.soltPath ? absoluteUrl(r.soltPath) : fallbackUrl;
            if (url) {
                item.url = url;
            }
            return item;
        }),
    };
}

export function buildHubRestaurantItemListSchema(
    cityName: string,
    restaurants: GeoHubRestaurant[],
) {
    return buildRestaurantItemListSchema({
        name: `Where to eat in ${cityName}`,
        restaurants: restaurants.map((r) => ({
            name: r.name,
            description: r.fullDescription,
            soltPath: r.soltPath,
        })),
        fallbackUrl: undefined,
    });
}
